import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  card: {
    width: '100%'
  },
  cardContent: {
    '&:last-child': {
      paddingBottom: 8
    }
  },
  title: {
    fontSize: 18,
    fontWeight: 600
  },
  boxItem: {
    display: 'flex',
    paddingTop: 8,
    paddingBottom: 8,
    maxWidth: 220
  },
  description: {
    fontWeight: 600,
    fontSize: 14
  },
  divider: {
    paddingTop: 8,
    paddingBottom: 8
  }
}))
